module.exports = __webpack_public_path__ + "img/zpqs-2.9c66ca5d.jpg";